export * from './sanitizeHtml'
export * from './date'
export * from './cycleDiscount'
export const getLocalStorageItem = (name: string) => {
  return window.localStorage.getItem(name)
}
export const setLocalStorageItem = (name: string, value: string) => {
  window.localStorage.setItem(name, value)
}
export const removeLocalStorageItem = (name: string) => {
  window.localStorage.removeItem(name)
}
export const decodeJwtToken = (token: string) => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace('-', '+').replace('_', '/')
  return JSON.parse(atob(base64))
}
export const getRandomColor = () => {
  // Generate random values for RGB components
  const r = Math.floor(Math.random() * 256)
  const g = Math.floor(Math.random() * 256)
  const b = Math.floor(Math.random() * 256)

  // Construct the color string in hexadecimal format
  const color =
    '#' + r.toString(16).padStart(2, '0') + g.toString(16).padStart(2, '0') + b.toString(16).padStart(2, '0')

  return color
}

export const formatStampToMinutes = (stamp: string) => {
  if (!stamp) return ''
  const parts = stamp.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/)
  return parts ? `${parts[1]} ${parts[2]}` : stamp
}
